<template>
  <div class="login-form">
    <div class="btns">
      <router-link to="/login" class="active">登录</router-link>
      <router-link to="/register">注册</router-link>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0"
      class="form"
    >
      <el-form-item prop="name">
        <el-input
          v-model="ruleForm.email"
          placeholder="请输入您的用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input
          type="password"
          v-model="ruleForm.pwd"
          placeholder="请输入您的密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="type">
        <el-checkbox
          label="记住登录状态"
          v-model="ruleForm.remberme"
        ></el-checkbox>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" size="small"
          >登 录</el-button
        >
        <router-link href="" class="forget" to="/forgetpassword"
          >忘记密码?</router-link
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Login",
  mounted() {
    this.from = this.$route.query["from"];
    console.log(this.from);
  },

  data() {
    return {
      from: "/",
      ruleForm: {
        name: "",
        email: "",
        pwd: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        // name: [
        //   { required: true, message: "邮箱不能为空", trigger: "blur" },
        //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        // ],
        // pwd: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            username: this.ruleForm.email,
            password: this.ruleForm.pwd,
          };
          let http = this.$http.create();
          http.defaults.headers.common["Content-Type"] =
            "application/x-www-form-urlencoded";
          http.post("/fireeye/public/login", qs.stringify(data)).then((res) => {
            console.log(res);
            let data = res.data;
            if (data.code === 1) {
              window.localStorage.setItem("isLogin", "1");
              data = data.data;
              window.localStorage.setItem("session", data.session);
              this.$root.isLogin = true;
              console.log(this.$router);

              this.$router.replace({ path: !!this.from ? this.from : "/" });
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.login-form {
  width: 340px;
  text-align: left;
  .btns {
    margin-bottom: 20px;
    a {
      text-decoration: none;
      padding: 5px 10px;
      color: #000;
      font-weight: 600;
    }
    .active {
      border-bottom: 2px solid #0093ff;
    }
  }
  .form {
    .el-button {
      padding: 8px 40px;
      margin-right: 20px;
    }
    .forget {
      text-decoration: none;
      font-weight: 600;
      font-size: 12px;
      color: #000;
    }
  }
}
</style>